'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    tableCellClassName: function() {
        return tableCellClassName;
    },
    tableCellClassNames: function() {
        return tableCellClassNames;
    },
    useTableCellStyles_unstable: function() {
        return useTableCellStyles_unstable;
    }
});
const _react = require("@griffel/react");
const tableCellClassName = 'fui-TableCell';
const tableCellClassNames = {
    root: tableCellClassName
};
const useTableLayoutStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        mc9l5x: "f15pt5es",
        ha4doy: "fmrv4ls"
    },
    medium: {
        Bqenvij: "f1ft4266"
    },
    small: {
        Bqenvij: "fbsu25e"
    },
    "extra-small": {
        Bqenvij: "frvgh55"
    }
}, {
    d: [
        ".f15pt5es{display:table-cell;}",
        ".fmrv4ls{vertical-align:middle;}",
        ".f1ft4266{height:44px;}",
        ".fbsu25e{height:34px;}",
        ".frvgh55{height:24px;}"
    ]
});
const useFlexLayoutStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        mc9l5x: "f22iagw",
        Bf4jedk: "f10tiqix",
        Bt984gj: "f122n59",
        xawz: 0,
        Bh6795r: 0,
        Bnnss6s: 0,
        fkmc3a: "f1izfyrr"
    },
    medium: {
        sshi5w: "f5pgtk9"
    },
    small: {
        sshi5w: "fcep9tg"
    },
    "extra-small": {
        sshi5w: "f1pha7fy"
    }
}, {
    d: [
        ".f22iagw{display:flex;}",
        ".f10tiqix{min-width:0px;}",
        ".f122n59{align-items:center;}",
        [
            ".f1izfyrr{flex:1 1 0px;}",
            {
                p: -1
            }
        ],
        ".f5pgtk9{min-height:44px;}",
        ".fcep9tg{min-height:34px;}",
        ".f1pha7fy{min-height:24px;}"
    ]
});
/**
 * Styles for the root slot
 */ const useStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        qhf8xq: "f10pi13n",
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: "f3gpkru",
        Bfpq7zp: 0,
        g9k6zt: 0,
        Bn4voq9: 0,
        giviqs: "f1dxfoyt",
        Bw81rd7: 0,
        kdpuga: 0,
        dm238s: 0,
        B6xbmo0: 0,
        B3whbx2: "f2krc9w"
    }
}, {
    d: [
        ".f10pi13n{position:relative;}",
        [
            ".f3gpkru{padding:0px var(--spacingHorizontalS);}",
            {
                p: -1
            }
        ],
        [
            ".f1dxfoyt[data-fui-focus-visible]{outline:2px solid var(--colorStrokeFocus2);}",
            {
                p: -1
            }
        ],
        [
            ".f2krc9w[data-fui-focus-visible]{border-radius:var(--borderRadiusMedium);}",
            {
                p: -1
            }
        ]
    ]
});
const useTableCellStyles_unstable = (state)=>{
    'use no memo';
    const styles = useStyles();
    const layoutStyles = {
        table: useTableLayoutStyles(),
        flex: useFlexLayoutStyles()
    };
    state.root.className = (0, _react.mergeClasses)(tableCellClassNames.root, styles.root, state.noNativeElements ? layoutStyles.flex.root : layoutStyles.table.root, state.noNativeElements ? layoutStyles.flex[state.size] : layoutStyles.table[state.size], state.root.className);
    return state;
};
